<template>
    <transition name="slide-fade">
        <div
            class="fixed top-2 right-2 z-20"
            v-if="toast && visible && !popstate"
        >
            <div
                class="
                    flex
                    items-center
                    text-white
                    max-w-sm
                    w-full
                    shadow-md
                    rounded-lg
                    overflow-hidden
                    mx-auto
                "
                :class="`bg-${color}-400`"
            >
            <span class="sr-only bg-red-400 bg-green-400 bg-blue-400 bg-yellow-400"></span>
                <div class="w-10 border-r px-2">
                    <Icons :name="toast.type" />
                </div>

                <div class="flex items-center px-2 py-3">
                    <div class="mx-3">
                        <p class="text-justify">{{ toast.message }}</p>
                    </div>
                </div>
                <div class="w-10 border-l px-2">
                    <button
                        @click="visible = false"
                        class="
                            w-6
                            h-6
                            rounded-full
                            flex
                            justify-center
                            items-center
                        "
                        :class="`hover:bg-${color}-500`"
                    >
                        <Icons name="close" />
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import Icons from "@/Components/Icons";
export default {
    data() {
        return {
            visible: false,
            timeout: "",
        };
    },
    props: {
        toast: {
            type: Object,
            default: "success",
        },
        popstate: Boolean,
    },
    watch: {
        toast: {
            immediate: true,
            handler() {
                if (this.toast) {
                    this.visible = true;
                    if (this.timeout) {
                        clearTimeout(this.timeout);
                    }
                    this.timeout = setTimeout(
                        () => (this.visible = false),
                        this.toast.duration ?? 1500
                    );
                }
            },
        },
    },
    computed: {
        color() {
            return {
                success: "green",
                error: "red",
                info: "blue",
                warning: "yellow",
            }[this.toast.type];
        },
    },
    components: {
        Icons,
    },
};
</script>
<style scoped>
.slide-fade-enter-active {
    transition: all 0.3s ease;
}

.slide-fade-leave-active {
    transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateX(150px);
    opacity: 0;
}
</style>
